import { render, staticRenderFns } from "./policyHolderDetailInfo.vue?vue&type=template&id=02d3c7c4&scoped=true&"
import script from "./policyHolderDetailInfo.vue?vue&type=script&lang=js&"
export * from "./policyHolderDetailInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d3c7c4",
  null
  
)

export default component.exports